import GetUserInfoService from "../../../service/GetUserInfoService";
import PhysicalStoreService from "../../../service/PhysicalStoreService";
import { formatDate } from "../../../utilities/formatDate";

class DashboardService {
  constructor() {
    this.getUserInfoService = new GetUserInfoService();
    this.physicalStoreService = new PhysicalStoreService();
  }

  getToken() {
    return localStorage.getItem("__extraconomy_token");
  }

  getUsername() {
    return localStorage.getItem("__extraconomy_username");
  }

  async getUserInfo() {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getUserInfo(token, username);
    return response;
  }

  async getWalletInfo() {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getWalletInfo(token, username);
    return response;
  }

  async getExtracoinInfo() {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getExtracoinInfo(token, username);
    return response;
  }

  async getWalletExtrabonus() {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getWalletExtrabonus(token, username);
    return response;
  }

  async getWalletLifetimeBonus() {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getWalletLifetimeBonus(token, username);
    return response;
  }

  async getBonusTransactions(dateBegin, dateEnd) {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getBonusTransactions(
      token,
      username,
      dateBegin,
      dateEnd,
    );
    return response;
  }

  async getNetworkDirectsInfo() {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getNetworkDirectsInfo(token, username);
    return response;
  }

  async getNetworkAllInfo() {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getNetworkAllInfo(token, username);
    return response;
  }

  async getSubscriptionInfo() {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getSubscriptionInfo(token, username);
    return response;
  }

  async getActivationInfo() {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getActivationInfo(token, username);
    return response;
  }

  async getExtracoinPercentage() {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getExtracoinPercentage(token, username);
    return response;
  }

  async getStorePayments() {
    const response = await this.physicalStoreService.getAllPayments();
    return response;
  }

  async getStatisticsGraph(interval) {
    const token = this.getToken();
    const username = this.getUsername();
    const response = await this.getUserInfoService.getStatisticsGraph(token, interval, username);
    return response;
  }

  getMockPerformanceChartData(interval) {
    const today = new Date();
    const data = [];
    const labels = [];

    if (interval === 30) {
      for (let i = 0; i <= 30; i++) {
        const date = new Date(today);
        date.setUTCDate(date.getUTCDate() - (30 - i));
        labels.push(formatDate(date));
        data.push(Math.floor(Math.random() * 200) + 50);
      }
    } else {
      const months = interval / 30;
      const monthNames = [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ];

      for (let i = months - 1; i >= 0; i--) {
        const date = new Date(today);
        date.setUTCMonth(date.getUTCMonth() - i);
        const monthIndex = date.getUTCMonth();
        const year = date.getUTCFullYear();
        labels.push(`${monthNames[monthIndex]} ${year}`);
        data.push(Math.floor(Math.random() * 200) + 50);
      }
    }

    return {
      labels,
      datasets: [
        {
          label: "Desempenho Comercial",
          data,
          backgroundColor: function (context) {
            const chart = context.chart;
            const { ctx, chartArea } = chart || {};
            if (!ctx || !chartArea) return null;

            // Função para buscar valor da var CSS ou fallback
            function getCSSVar(varName, fallback) {
              if (typeof window !== "undefined" && window.getComputedStyle) {
                return (
                  getComputedStyle(document.documentElement).getPropertyValue(varName)?.trim() ||
                  fallback
                );
              }
              return fallback;
            }

            // Obtém o valor de --theme-primary (esperado algo como "#46A748" ou "rgb(70,167,72)")
            let themePrimary = getCSSVar("--theme-primary", "#46A748");
            // Converte para rgba com opacidade baixa
            function cssColorToRgba(c, alpha) {
              if (!c) return `rgba(70,167,72,${alpha})`;
              // Remove espaços
              c = c.replace(/\s+/g, "");
              if (c.startsWith("#")) {
                // Suporte a #RRGGBB e #RGB
                let r, g, b;
                if (c.length === 7) {
                  r = parseInt(c.substr(1, 2), 16);
                  g = parseInt(c.substr(3, 2), 16);
                  b = parseInt(c.substr(5, 2), 16);
                } else if (c.length === 4) {
                  r = parseInt(c[1] + c[1], 16);
                  g = parseInt(c[2] + c[2], 16);
                  b = parseInt(c[3] + c[3], 16);
                } else {
                  // fallback para verde padrão
                  return `rgba(70,167,72,${alpha})`;
                }
                return `rgba(${r},${g},${b},${alpha})`;
              }
              if (c.startsWith("rgb(")) {
                return c.replace(/^rgb\((.*)\)$/i, `rgba($1,${alpha})`);
              }
              if (c.startsWith("rgba(")) {
                return c.replace(
                  /rgba\(([^,]+),([^,]+),([^,]+),[^)]+\)/i,
                  `rgba($1,$2,$3,${alpha})`,
                );
              }
              // fallback
              return `rgba(70,167,72,${alpha})`;
            }

            const colorTop = cssColorToRgba(themePrimary, 0.8); // Topo: mais forte
            const colorBottom = cssColorToRgba(themePrimary, 0.02); // Abaixo: opaco

            const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
            gradient.addColorStop(0, colorBottom);
            gradient.addColorStop(1, colorTop);
            return gradient;
          },
          fill: true,
          pointRadius: 3,
          tension: 0,
        },
      ],
    };
  }

  getMockRecentOperations() {
    return [
      {
        productName: "Apple Watch S5 GPS 40MM",
        price: 48,
        ticket: "TKT-98745",
        timeAgo: "12min",
        image: "https://via.assets.so/img.jpg?w=400&h=400&bg=e9d5ff&f=png",
      },
      {
        productName: "AirPods Max Green",
        price: 85,
        ticket: "TKT-98744",
        timeAgo: "14min",
        image: "https://via.assets.so/img.jpg?w=400&h=400&bg=1f2937&f=png",
      },
      {
        productName: "iMac M1 24-inch Purple",
        price: 385,
        ticket: "TKT-98743",
        timeAgo: "15min",
        image: "https://via.assets.so/img.jpg?w=400&h=400&bg=fee2e2&f=png",
      },
      {
        productName: "iPhone 15 PRO 512GB",
        price: 485,
        ticket: "TKT-98742",
        timeAgo: "20min",
        image: "https://via.assets.so/img.jpg?w=400&h=400&bg=e5e7eb&f=png",
      },
    ];
  }

  async handleEvaluationClick() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message: "Redirecionando para avaliação...",
        });
      }, 100);
    });
  }

  getMockNotifications() {
    const now = new Date();
    return [
      {
        id: 1,
        title: "Novo pedido recebido",
        message: "Você recebeu um novo pedido #12345",
        icon: "pi pi-shopping-cart",
        date: new Date(now.getTime() - 5 * 60000),
        read: false,
      },
      {
        id: 2,
        title: "Pagamento aprovado",
        message: "Seu pagamento de €150 foi aprovado",
        icon: "pi pi-check-circle",
        date: new Date(now.getTime() - 30 * 60000),
        read: false,
      },
      {
        id: 3,
        title: "Produto em estoque",
        message: "O produto iPhone 15 PRO está disponível novamente",
        icon: "pi pi-box",
        date: new Date(now.getTime() - 2 * 3600000),
        read: true,
      },
      {
        id: 4,
        title: "Nova avaliação",
        message: "Você recebeu uma nova avaliação de 5 estrelas",
        icon: "pi pi-star",
        date: new Date(now.getTime() - 5 * 3600000),
        read: true,
      },
      {
        id: 5,
        title: "Bônus disponível",
        message: "Seu bônus de rede está disponível para saque",
        icon: "pi pi-money-bill",
        date: new Date(now.getTime() - 24 * 3600000),
        read: false,
      },
    ];
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
